var React = require('react');

function UserInfo1 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"b"},React.createElement("rect",{"width":"24","height":"24"}))),React.createElement("g",{"id":"a","clipPath":"url(#b)","key":1},React.createElement("path",{"d":"M14.81,12.28a3.73,3.73,0,0,0,1-2.5,3.78,3.78,0,0,0-7.56,0,3.73,3.73,0,0,0,1,2.5A5.94,5.94,0,0,0,6,16.89a1.006,1.006,0,0,0,2,.22,4,4,0,0,1,7.94,0A1,1,0,0,0,17,18h.11a1,1,0,0,0,.88-1.1,5.94,5.94,0,0,0-3.18-4.62ZM12,11.56a1.78,1.78,0,1,1,1.78-1.78A1.78,1.78,0,0,1,12,11.56ZM19,2H5A3,3,0,0,0,2,5V19a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V5A3,3,0,0,0,19,2Zm1,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z","fill":"#00008f"}))]);
}

UserInfo1.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = UserInfo1;

UserInfo1.default = UserInfo1;
